import Compass from '@arcgis/core/widgets/Compass';

export const COMPASS_WIDGET_TITLE = 'compass-widget';

/**
 * Create and return an instance of the Compass widget to be added to the map.
 * https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Compass.html
 * @param {Object} mapView - the map view associated with the compass widget
 */
export const createCompassWidget = ({ mapView }) => {
  return new Compass({
    id: COMPASS_WIDGET_TITLE,
    view: mapView,
    visible: true,
  });
};
